import { AppShell } from './AppShell/AppShell';
import styles from './LoadingView.module.css';

export function LoadingView({ message = 'Loading project…' }: { message?: string }) {
  return (
    <AppShell variant="logo-only">
      <main className={styles.wrap}>
        <div className={styles.inner}>
          <div className={styles.spinner} aria-hidden="true" />
          <div className={styles.message}>{message}</div>
        </div>
      </main>
    </AppShell>
  );
}
